// import React, {useEffect, useState} from "react";
// import Layout from "../../Layout";
// import {FaEye, FaEyeSlash} from "react-icons/fa";
// import {message, Spin} from "antd";
//
// const ProfilePage = () => {
//     const server_url = "http://127.0.0.1:8090";
//     const accessToken = localStorage.getItem("accessToken");
//
//     // Form state for AdminUserUpdate
//     const [formData, setFormData] = useState({
//         // Basic Fields
//         name: "",
//         email: "",
//         password: "",
//         confirmPassword: "",
//         role: "admin", // We'll force admin role here for clarity
//
//         // Admin-Specific Fields
//         middle_name: "",
//         date_of_birth: "",
//         contact_info_email: "",
//         contact_info_phone: "",
//         gender: "",
//         address: "",
//
//         // Professional Information
//         current_school: "",
//         total_experience: "",
//         past_schools: "",
//         educational_qualifications: "",
//         professional_achievements: "",
//         languages_spoken: "",
//         leadership_style: "",
//         committees_boards: "",
//
//         // Visionary and Strategic Elements
//         school_goals: "",
//         improvement_strategies: "",
//         extracurricular_strategies: "",
//         teacher_development: "",
//
//         // Skills & Expertise
//         specializations: "",
//         conflict_resolution: "",
//         project_management: "",
//
//         // Engagement & Feedback
//         feedback: "",
//         communication_channels: "",
//         engaged_activities: "",
//
//         // Administrative Details
//         key_responsibilities: "",
//         budget_management: "",
//         disciplinary_philosophy: "",
//         tech_integration: "",
//
//         // Multimedia & Additional Fields
//         video_intro: "",
//         portfolio_link: "",
//         personal_motto: "",
//
//         // Personalization
//         favorite_quotes: "",
//         hobbies: "",
//         recommended_books: "",
//     });
//
//     const [loading, setLoading] = useState(false);
//     const [warning, setWarning] = useState("");
//     const [passwordShown, setPasswordShown] = useState(false);
//     const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
//
//     // Toggle password visibility
//     const togglePasswordVisibility = () => setPasswordShown(!passwordShown);
//     const toggleConfirmPasswordVisibility = () =>
//         setConfirmPasswordShown(!confirmPasswordShown);
//
//     // Handle input changes
//     const handleInputChange = (event) => {
//         const {name, value} = event.target;
//         setFormData({...formData, [name]: value});
//     };
//
//     // Optional: Fetch existing admin profile data from /admin/profile to prefill the form
//     const fetchAdminProfile = async () => {
//         setLoading(true);
//         try {
//             const response = await fetch(`${server_url}/admin/profile`, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//             });
//             const data = await response.json();
//             if (!response.ok) {
//                 throw new Error(data.detail || "Failed to load admin profile.");
//             }
//
//             // Prefill formData with existing admin profile fields
//             setFormData((prev) => ({
//                 ...prev,
//                 name: data.name || "",
//                 email: data.email || "",
//                 // We'll keep password fields empty
//                 role: data.role || "admin",
//
//                 // Admin-Specific
//                 middle_name: data.middle_name || "",
//                 date_of_birth: data.date_of_birth || "",
//                 contact_info_email: data.contact_info?.email || "",
//                 contact_info_phone: data.contact_info?.phone || "",
//                 gender: data.gender || "",
//                 address: data.address || "",
//
//                 // Professional Information
//                 current_school: data.current_school || "",
//                 total_experience: data.total_experience?.toString() || "",
//                 past_schools: Array.isArray(data.past_schools)
//                     ? data.past_schools.join(", ")
//                     : "",
//                 educational_qualifications: Array.isArray(data.educational_qualifications)
//                     ? data.educational_qualifications.join(", ")
//                     : "",
//                 professional_achievements: Array.isArray(data.professional_achievements)
//                     ? data.professional_achievements.join(", ")
//                     : "",
//                 languages_spoken: Array.isArray(data.languages_spoken)
//                     ? data.languages_spoken.join(", ")
//                     : "",
//                 leadership_style: data.leadership_style || "",
//                 committees_boards: Array.isArray(data.committees_boards)
//                     ? data.committees_boards.join(", ")
//                     : "",
//
//                 // Visionary & Strategic
//                 school_goals: data.school_goals || "",
//                 improvement_strategies: data.improvement_strategies || "",
//                 extracurricular_strategies: data.extracurricular_strategies || "",
//                 teacher_development: data.teacher_development || "",
//
//                 // Skills & Expertise
//                 specializations: Array.isArray(data.specializations)
//                     ? data.specializations.join(", ")
//                     : "",
//                 conflict_resolution: data.conflict_resolution || "",
//                 project_management: data.project_management || "",
//
//                 // Engagement & Feedback
//                 feedback: data.feedback || "",
//                 communication_channels: data.communication_channels || "",
//                 engaged_activities: data.engaged_activities || "",
//
//                 // Administrative
//                 key_responsibilities: data.key_responsibilities || "",
//                 budget_management: data.budget_management || "",
//                 disciplinary_philosophy: data.disciplinary_philosophy || "",
//                 tech_integration: data.tech_integration || "",
//
//                 // Multimedia & Additional
//                 video_intro: data.video_intro || "",
//                 portfolio_link: data.portfolio_link || "",
//                 personal_motto: data.personal_motto || "",
//
//                 // Personalization
//                 favorite_quotes: data.favorite_quotes || "",
//                 hobbies: Array.isArray(data.hobbies) ? data.hobbies.join(", ") : "",
//                 recommended_books: Array.isArray(data.recommended_books)
//                     ? data.recommended_books.join(", ")
//                     : "",
//             }));
//         } catch (error) {
//             // message.error(error.message);
//             console.error("Error fetching admin profile:", error);
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     useEffect(() => {
//         fetchAdminProfile(); // Load existing admin profile data on mount
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);
//
//     // Submit form: calls /admin/update with AdminUserUpdate fields
//     const handleSubmit = async (event) => {
//         event.preventDefault();
//
//         // Check password match if password is provided
//         if (formData.password || formData.confirmPassword) {
//             if (formData.password !== formData.confirmPassword) {
//                 setWarning("Passwords do not match!");
//                 return;
//             }
//         }
//         setWarning("");
//
//         // Convert comma-separated strings into arrays
//         const parseArrayField = (str) =>
//             str
//                 ? str
//                     .split(",")
//                     .map((item) => item.trim())
//                     .filter((val) => val !== "")
//                 : [];
//
//         // Build request body
//         const updatePayload = {
//             // Basic
//             name: formData.name || undefined,
//             email: formData.email || undefined,
//             password: formData.password || undefined,
//             role: formData.role || undefined,
//
//             // Admin-Specific
//             middle_name: formData.middle_name || undefined,
//             date_of_birth: formData.date_of_birth || undefined,
//             contact_info: {
//                 email: formData.contact_info_email || "",
//                 phone: formData.contact_info_phone || "",
//             },
//             gender: formData.gender || undefined,
//             address: formData.address || undefined,
//
//             // Professional
//             current_school: formData.current_school || undefined,
//             total_experience:
//                 formData.total_experience !== ""
//                     ? parseInt(formData.total_experience, 10)
//                     : undefined,
//             past_schools: parseArrayField(formData.past_schools),
//             educational_qualifications: parseArrayField(
//                 formData.educational_qualifications
//             ),
//             professional_achievements: parseArrayField(
//                 formData.professional_achievements
//             ),
//             languages_spoken: parseArrayField(formData.languages_spoken),
//             leadership_style: formData.leadership_style || undefined,
//             committees_boards: parseArrayField(formData.committees_boards),
//
//             // Visionary & Strategic
//             school_goals: formData.school_goals || undefined,
//             improvement_strategies: formData.improvement_strategies || undefined,
//             extracurricular_strategies: formData.extracurricular_strategies || undefined,
//             teacher_development: formData.teacher_development || undefined,
//
//             // Skills & Expertise
//             specializations: parseArrayField(formData.specializations),
//             conflict_resolution: formData.conflict_resolution || undefined,
//             project_management: formData.project_management || undefined,
//
//             // Engagement & Feedback
//             feedback: formData.feedback || undefined,
//             communication_channels: formData.communication_channels || undefined,
//             engaged_activities: formData.engaged_activities || undefined,
//
//             // Administrative Details
//             key_responsibilities: formData.key_responsibilities || undefined,
//             budget_management: formData.budget_management || undefined,
//             disciplinary_philosophy: formData.disciplinary_philosophy || undefined,
//             tech_integration: formData.tech_integration || undefined,
//
//             // Multimedia & Additional Fields
//             video_intro: formData.video_intro || undefined,
//             portfolio_link: formData.portfolio_link || undefined,
//             personal_motto: formData.personal_motto || undefined,
//
//             // Personalization
//             favorite_quotes: formData.favorite_quotes || undefined,
//             hobbies: parseArrayField(formData.hobbies),
//             recommended_books: parseArrayField(formData.recommended_books),
//         };
//
//         try {
//             const response = await fetch(`${server_url}/admin/update`, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//                 body: JSON.stringify(updatePayload),
//             });
//             const data = await response.json();
//
//             if (response.ok) {
//                 message.success(data.message || "Profile updated successfully!");
//                 // Optionally reset password fields
//                 setFormData((prev) => ({
//                     ...prev,
//                     password: "",
//                     confirmPassword: "",
//                 }));
//             } else {
//                 console.error(data.detail || "Failed to update profile.");
//             }
//         } catch (error) {
//             console.error("Error updating profile:", error);
//             // message.error("Error updating profile.");
//         }
//     };
//
//     // Rendering
//     return (
//         <>
//             <div className="flex flex-col items-center w-full px-4 sm:px-6 lg:px-8 mt-10">
//                 <div className="w-full max-w-4xl p-10 bg-white dark:bg-gray-900 rounded-lg shadow-md">
//                     <h2 className="text-3xl font-semibold font-gotham text-gray-800 dark:text-white mb-6 text-center">
//                         Update Admin Profile
//                     </h2>
//
//                     {loading ? (
//                         <div className="flex justify-center items-center">
//                             <Spin size="large"/>
//                         </div>
//                     ) : (
//                         <form onSubmit={handleSubmit} className="space-y-6 font-gotham">
//                             {/* BASIC INFO */}
//                             <div className="flex flex-col font-gotham">
//                                 <label className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
//                                     Name
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="name"
//                                     placeholder="Enter your name"
//                                     value={formData.name}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
//                                 />
//                             </div>
//
//                             <div className="flex flex-col">
//                                 <label
//                                     className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-2 font-gotham">
//                                     Email
//                                 </label>
//                                 <input
//                                     type="email"
//                                     name="email"
//                                     placeholder="Enter your email"
//                                     value={formData.email}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 font-gotham"
//                                 />
//                             </div>
//
//                             {/* PASSWORD FIELDS */}
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
//                                         Password
//                                     </label>
//                                     <div className="relative">
//                                         <input
//                                             type={passwordShown ? "text" : "password"}
//                                             name="password"
//                                             placeholder="Enter new password"
//                                             value={formData.password}
//                                             onChange={handleInputChange}
//                                             className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
//                                         />
//                                         <span
//                                             onClick={togglePasswordVisibility}
//                                             className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-500"
//                                         >
//                       {passwordShown ? <FaEye/> : <FaEyeSlash/>}
//                     </span>
//                                     </div>
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
//                                         Confirm Password
//                                     </label>
//                                     <div className="relative">
//                                         <input
//                                             type={confirmPasswordShown ? "text" : "password"}
//                                             name="confirmPassword"
//                                             placeholder="Confirm new password"
//                                             value={formData.confirmPassword}
//                                             onChange={handleInputChange}
//                                             className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
//                                         />
//                                         <span
//                                             onClick={toggleConfirmPasswordVisibility}
//                                             className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-500"
//                                         >
//                       {confirmPasswordShown ? <FaEye/> : <FaEyeSlash/>}
//                     </span>
//                                     </div>
//                                 </div>
//                             </div>
//                             {warning && <p className="text-sm text-red-500 mt-2">{warning}</p>}
//
//                             {/* ADMIN-SPECIFIC FIELDS */}
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Middle Name
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="middle_name"
//                                         value={formData.middle_name}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="Middle Name"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Date of Birth
//                                     </label>
//                                     <input
//                                         type="date"
//                                         name="date_of_birth"
//                                         value={formData.date_of_birth}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                             </div>
//
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Contact Email
//                                     </label>
//                                     <input
//                                         type="email"
//                                         name="contact_info_email"
//                                         value={formData.contact_info_email}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="Separate contact email if different"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">Phone</label>
//                                     <input
//                                         type="text"
//                                         name="contact_info_phone"
//                                         value={formData.contact_info_phone}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="e.g., +1 234 567 890"
//                                     />
//                                 </div>
//                             </div>
//
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">Gender</label>
//                                     <select
//                                         name="gender"
//                                         value={formData.gender}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     >
//                                         <option value="">Select</option>
//                                         <option value="male">Male</option>
//                                         <option value="female">Female</option>
//                                         <option value="other">Other / Prefer not to say</option>
//                                     </select>
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">Address</label>
//                                     <input
//                                         type="text"
//                                         name="address"
//                                         value={formData.address}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="Admin's address"
//                                     />
//                                 </div>
//                             </div>
//
//                             {/* PROFESSIONAL INFO */}
//                             <h3 className="text-lg font-semibold mt-8">Professional Info</h3>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Current School
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="current_school"
//                                         value={formData.current_school}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Total Experience (years)
//                                     </label>
//                                     <input
//                                         type="number"
//                                         name="total_experience"
//                                         value={formData.total_experience}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         min={0}
//                                     />
//                                 </div>
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Past Schools (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="past_schools"
//                                     value={formData.past_schools}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     placeholder="e.g., School A, School B"
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Educational Qualifications (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="educational_qualifications"
//                                     value={formData.educational_qualifications}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     placeholder="e.g., B.Ed, M.Ed"
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Professional Achievements (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="professional_achievements"
//                                     value={formData.professional_achievements}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Languages Spoken (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="languages_spoken"
//                                     value={formData.languages_spoken}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     placeholder="e.g., English, Hindi"
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Leadership Style
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="leadership_style"
//                                     value={formData.leadership_style}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg font-gotham"
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Committees/Boards (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="committees_boards"
//                                     value={formData.committees_boards}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//
//                             {/* VISIONARY */}
//                             <h3 className="text-lg font-semibold mt-8">Visionary & Strategy</h3>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     School Goals
//                                 </label>
//                                 <textarea
//                                     name="school_goals"
//                                     value={formData.school_goals}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={3}
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Improvement Strategies
//                                 </label>
//                                 <textarea
//                                     name="improvement_strategies"
//                                     value={formData.improvement_strategies}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={3}
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Extracurricular Strategies
//                                 </label>
//                                 <textarea
//                                     name="extracurricular_strategies"
//                                     value={formData.extracurricular_strategies}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={3}
//                                 />
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Teacher Development
//                                 </label>
//                                 <textarea
//                                     name="teacher_development"
//                                     value={formData.teacher_development}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={3}
//                                 />
//                             </div>
//
//                             {/* SKILLS */}
//                             <h3 className="text-lg font-semibold mt-8">Skills & Expertise</h3>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Specializations (comma separated)
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="specializations"
//                                     value={formData.specializations}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Conflict Resolution
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="conflict_resolution"
//                                         value={formData.conflict_resolution}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Project Management
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="project_management"
//                                         value={formData.project_management}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                             </div>
//
//                             {/* ENGAGEMENT & FEEDBACK */}
//                             <h3 className="text-lg font-semibold mt-8">
//                                 Engagement & Feedback
//                             </h3>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">Feedback</label>
//                                     <input
//                                         type="text"
//                                         name="feedback"
//                                         value={formData.feedback}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Communication Channels
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="communication_channels"
//                                         value={formData.communication_channels}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Engaged Activities
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="engaged_activities"
//                                     value={formData.engaged_activities}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//
//                             {/* ADMIN DETAILS */}
//                             <h3 className="text-lg font-semibold mt-8">
//                                 Administrative Details
//                             </h3>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Key Responsibilities
//                                 </label>
//                                 <textarea
//                                     name="key_responsibilities"
//                                     value={formData.key_responsibilities}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={3}
//                                 />
//                             </div>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Budget Management
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="budget_management"
//                                         value={formData.budget_management}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Disciplinary Philosophy
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="disciplinary_philosophy"
//                                         value={formData.disciplinary_philosophy}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Tech Integration
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="tech_integration"
//                                     value={formData.tech_integration}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//
//                             {/* MULTIMEDIA */}
//                             <h3 className="text-lg font-semibold mt-8">
//                                 Multimedia & Additional
//                             </h3>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Video Intro
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="video_intro"
//                                         value={formData.video_intro}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="e.g., YouTube link"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Portfolio Link
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="portfolio_link"
//                                         value={formData.portfolio_link}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                         placeholder="e.g., personal website"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Personal Motto
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="personal_motto"
//                                     value={formData.personal_motto}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                 />
//                             </div>
//
//                             {/* PERSONALIZATION */}
//                             <h3 className="text-lg font-semibold mt-8">Personalization</h3>
//                             <div className="flex flex-col">
//                                 <label className="text-sm font-medium mb-2">
//                                     Favorite Quotes
//                                 </label>
//                                 <textarea
//                                     name="favorite_quotes"
//                                     value={formData.favorite_quotes}
//                                     onChange={handleInputChange}
//                                     className="p-3 border rounded-lg"
//                                     rows={2}
//                                 />
//                             </div>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Hobbies (comma separated)
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="hobbies"
//                                         value={formData.hobbies}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <label className="text-sm font-medium mb-2">
//                                         Recommended Books (comma separated)
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="recommended_books"
//                                         value={formData.recommended_books}
//                                         onChange={handleInputChange}
//                                         className="p-3 border rounded-lg"
//                                     />
//                                 </div>
//                             </div>
//
//                             {/* SUBMIT BUTTON */}
//                             <button
//                                 type="submit"
//                                 className="w-full font-gotham py-3 mt-4 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-lg shadow-md transition duration-300"
//                             >
//                                 Update Admin Profile
//                             </button>
//                         </form>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// };
//
// export default ProfilePage;

import React, { useEffect, useState } from "react";
import { message, Spin } from "antd";
import {
    User,
    Mail,
    Phone,
    Calendar,
    Eye,
    EyeOff,
    MapPin,
    Building,
    Briefcase,
    GraduationCap,
    Award,
    Languages,
    Users,
    Target,
    PieChart,
    MessageSquare,
    Settings,
    Video,
    Link,
    Quote,
    Heart,
    BookOpen,
    Save,
    Lock,
    ShieldCheck,
    ChevronRight
} from "lucide-react";
import { API_BASE_URL } from "../config";
import BeneficiaryFeedbackCard from "../Components/BeneficiaryFeedbackCard";

const ProfilePage = () => {
    const server_url = API_BASE_URL;
    const accessToken = localStorage.getItem("accessToken");

    // Form state for AdminUserUpdate
    const [formData, setFormData] = useState({
        // Basic Fields
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        role: "admin", // We'll force admin role here for clarity

        // Admin-Specific Fields
        middle_name: "",
        date_of_birth: "",
        contact_info_email: "",
        contact_info_phone: "",
        gender: "",
        address: "",

        // Professional Information
        current_school: "",
        total_experience: "",
        past_schools: "",
        educational_qualifications: "",
        professional_achievements: "",
        languages_spoken: "",
        leadership_style: "",
        committees_boards: "",

        // Visionary and Strategic Elements
        school_goals: "",
        improvement_strategies: "",
        extracurricular_strategies: "",
        teacher_development: "",

        // Skills & Expertise
        specializations: "",
        conflict_resolution: "",
        project_management: "",

        // Engagement & Feedback
        feedback: "",
        communication_channels: "",
        engaged_activities: "",

        // Administrative Details
        key_responsibilities: "",
        budget_management: "",
        disciplinary_philosophy: "",
        tech_integration: "",

        // Multimedia & Additional Fields
        video_intro: "",
        portfolio_link: "",
        personal_motto: "",

        // Personalization
        favorite_quotes: "",
        hobbies: "",
        recommended_books: "",
    });

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [warning, setWarning] = useState("");
    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
    const [activeTab, setActiveTab] = useState("personal");

    // Toggle password visibility
    const togglePasswordVisibility = () => setPasswordShown(!passwordShown);
    const toggleConfirmPasswordVisibility = () =>
        setConfirmPasswordShown(!confirmPasswordShown);

    // Handle input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // Fetch existing admin profile data from /admin/profile to prefill the form
    const fetchAdminProfile = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${server_url}/admin/profile`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.detail || "Failed to load admin profile.");
            }

            // Prefill formData with existing admin profile fields
            setFormData((prev) => ({
                ...prev,
                name: data.name || "",
                email: data.email || "",
                // We'll keep password fields empty
                role: data.role || "admin",

                // Admin-Specific
                middle_name: data.middle_name || "",
                date_of_birth: data.date_of_birth || "",
                contact_info_email: data.contact_info?.email || "",
                contact_info_phone: data.contact_info?.phone || "",
                gender: data.gender || "",
                address: data.address || "",

                // Professional Information
                current_school: data.current_school || "",
                total_experience: data.total_experience?.toString() || "",
                past_schools: Array.isArray(data.past_schools)
                    ? data.past_schools.join(", ")
                    : "",
                educational_qualifications: Array.isArray(
                    data.educational_qualifications
                )
                    ? data.educational_qualifications.join(", ")
                    : "",
                professional_achievements: Array.isArray(data.professional_achievements)
                    ? data.professional_achievements.join(", ")
                    : "",
                languages_spoken: Array.isArray(data.languages_spoken)
                    ? data.languages_spoken.join(", ")
                    : "",
                leadership_style: data.leadership_style || "",
                committees_boards: Array.isArray(data.committees_boards)
                    ? data.committees_boards.join(", ")
                    : "",

                // Visionary & Strategic
                school_goals: data.school_goals || "",
                improvement_strategies: data.improvement_strategies || "",
                extracurricular_strategies: data.extracurricular_strategies || "",
                teacher_development: data.teacher_development || "",

                // Skills & Expertise
                specializations: Array.isArray(data.specializations)
                    ? data.specializations.join(", ")
                    : "",
                conflict_resolution: data.conflict_resolution || "",
                project_management: data.project_management || "",

                // Engagement & Feedback
                feedback: data.feedback || "",
                communication_channels: data.communication_channels || "",
                engaged_activities: data.engaged_activities || "",

                // Administrative
                key_responsibilities: data.key_responsibilities || "",
                budget_management: data.budget_management || "",
                disciplinary_philosophy: data.disciplinary_philosophy || "",
                tech_integration: data.tech_integration || "",

                // Multimedia & Additional
                video_intro: data.video_intro || "",
                portfolio_link: data.portfolio_link || "",
                personal_motto: data.personal_motto || "",

                // Personalization
                favorite_quotes: data.favorite_quotes || "",
                hobbies: Array.isArray(data.hobbies) ? data.hobbies.join(", ") : "",
                recommended_books: Array.isArray(data.recommended_books)
                    ? data.recommended_books.join(", ")
                    : "",
            }));
        } catch (error) {
            console.error("Error fetching admin profile:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAdminProfile(); // Load existing admin profile data on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Submit form: calls /admin/update with AdminUserUpdate fields
    const handleSubmit = async (event) => {
        if (event) event.preventDefault();

        if (formData.password || formData.confirmPassword) {
            if (formData.password !== formData.confirmPassword) {
                setWarning("Passwords do not match!");
                return;
            }
        }
        setWarning("");

        const parseArrayField = (str) =>
            str ? str.split(",").map((item) => item.trim()).filter((val) => val !== "") : [];

        const updatePayload = {
            name: formData.name || undefined,
            email: formData.email || undefined,
            password: formData.password || undefined,
            role: formData.role || undefined,
            middle_name: formData.middle_name || undefined,
            date_of_birth: formData.date_of_birth || undefined,
            contact_info: {
                email: formData.contact_info_email || "",
                phone: formData.contact_info_phone || "",
            },
            gender: formData.gender || undefined,
            address: formData.address || undefined,
            current_school: formData.current_school || undefined,
            total_experience: formData.total_experience !== "" ? parseInt(formData.total_experience, 10) : undefined,
            past_schools: parseArrayField(formData.past_schools),
            educational_qualifications: parseArrayField(formData.educational_qualifications),
            professional_achievements: parseArrayField(formData.professional_achievements),
            languages_spoken: parseArrayField(formData.languages_spoken),
            leadership_style: formData.leadership_style || undefined,
            committees_boards: parseArrayField(formData.committees_boards),
            school_goals: formData.school_goals || undefined,
            improvement_strategies: formData.improvement_strategies || undefined,
            extracurricular_strategies: formData.extracurricular_strategies || undefined,
            teacher_development: formData.teacher_development || undefined,
            specializations: parseArrayField(formData.specializations),
            conflict_resolution: formData.conflict_resolution || undefined,
            project_management: formData.project_management || undefined,
            feedback: formData.feedback || undefined,
            communication_channels: formData.communication_channels || undefined,
            engaged_activities: formData.engaged_activities || undefined,
            key_responsibilities: formData.key_responsibilities || undefined,
            budget_management: formData.budget_management || undefined,
            disciplinary_philosophy: formData.disciplinary_philosophy || undefined,
            tech_integration: formData.tech_integration || undefined,
            video_intro: formData.video_intro || undefined,
            portfolio_link: formData.portfolio_link || undefined,
            personal_motto: formData.personal_motto || undefined,
            favorite_quotes: formData.favorite_quotes || undefined,
            hobbies: parseArrayField(formData.hobbies),
            recommended_books: parseArrayField(formData.recommended_books),
        };

        setSaving(true);
        try {
            const response = await fetch(`${server_url}/admin/update`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(updatePayload),
            });
            const data = await response.json();

            if (response.ok) {
                message.success(data.message || "Profile updated successfully!");
                setFormData((prev) => ({ ...prev, password: "", confirmPassword: "" }));
                // Re-fetch to confirm data was persisted
                await fetchAdminProfile();
            } else {
                message.error(data.detail || "Failed to update profile.");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            message.error("Network error — could not save profile.");
        } finally {
            setSaving(false);
        }
    };

    const menuItems = [
        { id: "personal",       label: "Personal",        icon: <User size={16} /> },
        { id: "professional",   label: "Professional",    icon: <Briefcase size={16} /> },
        { id: "vision",         label: "Vision & Strategy", icon: <Target size={16} /> },
        { id: "skills",         label: "Skills & Expertise", icon: <Award size={16} /> },
        { id: "engagement",     label: "Engagement",      icon: <MessageSquare size={16} /> },
        { id: "administrative", label: "Administrative",  icon: <Settings size={16} /> },
        { id: "multimedia",     label: "Multimedia",      icon: <Video size={16} /> },
        { id: "personalization",label: "Personalization", icon: <Heart size={16} /> },
    ];

    // Shared input className
    const inputCls = "w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#D67C2C] focus:border-transparent bg-white transition-shadow";
    const labelCls = "block text-xs font-semibold text-[#617587] uppercase tracking-wide mb-1.5";

    const SectionHeader = ({ icon, title, subtitle }) => (
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
            <div className="w-10 h-10 rounded-xl bg-[#fff4eb] flex items-center justify-center text-[#D67C2C] flex-shrink-0">
                {icon}
            </div>
            <div>
                <h2 className="text-[17px] font-bold text-[#1D3469] leading-tight">{title}</h2>
                {subtitle && <p className="text-xs text-[#617587] mt-0.5">{subtitle}</p>}
            </div>
        </div>
    );

    const renderFormSection = () => {
        switch (activeTab) {
            case "personal":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<User size={20} />} title="Personal Information" subtitle="Basic identity and contact details" />

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}>Full Name</label>
                                <input type="text" name="name" placeholder="Enter your name" value={formData.name} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}>Middle Name</label>
                                <input type="text" name="middle_name" placeholder="Middle name (optional)" value={formData.middle_name} onChange={handleInputChange} className={inputCls} /></div>
                        </div>

                        <div><label className={labelCls}><Mail size={12} className="inline mr-1" />Email Address</label>
                            <input type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleInputChange} className={inputCls} /></div>

                        <div className="bg-[#fff8f3] border border-[#f7c9a1] rounded-xl p-4">
                            <p className="text-xs font-semibold text-[#D67C2C] mb-3 flex items-center gap-1.5"><Lock size={12} />Change Password (leave blank to keep current)</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div><label className={labelCls}>New Password</label>
                                    <div className="relative">
                                        <input type={passwordShown ? "text" : "password"} name="password" placeholder="Enter new password" value={formData.password} onChange={handleInputChange} className={inputCls} />
                                        <button type="button" onClick={togglePasswordVisibility} className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600">
                                            {passwordShown ? <EyeOff size={16} /> : <Eye size={16} />}
                                        </button>
                                    </div>
                                </div>
                                <div><label className={labelCls}>Confirm Password</label>
                                    <div className="relative">
                                        <input type={confirmPasswordShown ? "text" : "password"} name="confirmPassword" placeholder="Confirm new password" value={formData.confirmPassword} onChange={handleInputChange} className={inputCls} />
                                        <button type="button" onClick={toggleConfirmPasswordVisibility} className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600">
                                            {confirmPasswordShown ? <EyeOff size={16} /> : <Eye size={16} />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {warning && <p className="text-xs text-red-500 mt-2">{warning}</p>}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}><Calendar size={12} className="inline mr-1" />Date of Birth</label>
                                <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}><Users size={12} className="inline mr-1" />Gender</label>
                                <select name="gender" value={formData.gender} onChange={handleInputChange} className={inputCls}>
                                    <option value="">Select gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other / Prefer not to say</option>
                                </select>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}><Mail size={12} className="inline mr-1" />Contact Email</label>
                                <input type="email" name="contact_info_email" placeholder="Alternate contact email" value={formData.contact_info_email} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}><Phone size={12} className="inline mr-1" />Phone</label>
                                <input type="text" name="contact_info_phone" placeholder="e.g., +1 234 567 890" value={formData.contact_info_phone} onChange={handleInputChange} className={inputCls} /></div>
                        </div>

                        <div><label className={labelCls}><MapPin size={12} className="inline mr-1" />Address</label>
                            <textarea name="address" placeholder="Full address" value={formData.address} onChange={handleInputChange} rows={3} className={inputCls} /></div>
                    </div>
                );

            case "professional":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Briefcase size={20} />} title="Professional Information" subtitle="Career background and qualifications" />

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}><Building size={12} className="inline mr-1" />Current School</label>
                                <input type="text" name="current_school" value={formData.current_school} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}><Briefcase size={12} className="inline mr-1" />Total Experience (years)</label>
                                <input type="number" name="total_experience" value={formData.total_experience} onChange={handleInputChange} min={0} className={inputCls} /></div>
                        </div>

                        <div><label className={labelCls}><Building size={12} className="inline mr-1" />Past Schools <span className="normal-case font-normal">(comma separated)</span></label>
                            <input type="text" name="past_schools" placeholder="School A, School B" value={formData.past_schools} onChange={handleInputChange} className={inputCls} /></div>

                        <div><label className={labelCls}><GraduationCap size={12} className="inline mr-1" />Educational Qualifications <span className="normal-case font-normal">(comma separated)</span></label>
                            <input type="text" name="educational_qualifications" placeholder="B.Ed, M.Ed" value={formData.educational_qualifications} onChange={handleInputChange} className={inputCls} /></div>

                        <div><label className={labelCls}><Award size={12} className="inline mr-1" />Professional Achievements <span className="normal-case font-normal">(comma separated)</span></label>
                            <input type="text" name="professional_achievements" value={formData.professional_achievements} onChange={handleInputChange} className={inputCls} /></div>

                        <div><label className={labelCls}><Languages size={12} className="inline mr-1" />Languages Spoken <span className="normal-case font-normal">(comma separated)</span></label>
                            <input type="text" name="languages_spoken" placeholder="English, Hindi" value={formData.languages_spoken} onChange={handleInputChange} className={inputCls} /></div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}>Leadership Style</label>
                                <input type="text" name="leadership_style" value={formData.leadership_style} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}>Committees / Boards <span className="normal-case font-normal">(comma separated)</span></label>
                                <input type="text" name="committees_boards" value={formData.committees_boards} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                    </div>
                );

            case "vision":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Target size={20} />} title="Vision & Strategy" subtitle="School goals and improvement plans" />
                        {[
                            { name: "school_goals", label: "School Goals", icon: <Target size={12} /> },
                            { name: "improvement_strategies", label: "Improvement Strategies", icon: <PieChart size={12} /> },
                            { name: "extracurricular_strategies", label: "Extracurricular Strategies", icon: <Target size={12} /> },
                            { name: "teacher_development", label: "Teacher Development", icon: <Users size={12} /> },
                        ].map(({ name, label, icon }) => (
                            <div key={name}><label className={labelCls}>{icon && React.cloneElement(icon, { className: "inline mr-1" })}{label}</label>
                                <textarea name={name} value={formData[name]} onChange={handleInputChange} rows={3} className={inputCls} /></div>
                        ))}
                    </div>
                );

            case "skills":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Award size={20} />} title="Skills & Expertise" subtitle="Competencies and specializations" />
                        <div><label className={labelCls}><Award size={12} className="inline mr-1" />Specializations <span className="normal-case font-normal">(comma separated)</span></label>
                            <input type="text" name="specializations" value={formData.specializations} onChange={handleInputChange} className={inputCls} /></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}>Conflict Resolution</label>
                                <input type="text" name="conflict_resolution" value={formData.conflict_resolution} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}>Project Management</label>
                                <input type="text" name="project_management" value={formData.project_management} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                    </div>
                );

            case "engagement":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<MessageSquare size={20} />} title="Engagement & Feedback" subtitle="Communication and community involvement" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}>Feedback Style</label>
                                <input type="text" name="feedback" value={formData.feedback} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}>Communication Channels</label>
                                <input type="text" name="communication_channels" value={formData.communication_channels} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                        <div><label className={labelCls}>Engaged Activities</label>
                            <input type="text" name="engaged_activities" value={formData.engaged_activities} onChange={handleInputChange} className={inputCls} /></div>
                    </div>
                );

            case "administrative":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Settings size={20} />} title="Administrative Details" subtitle="Responsibilities and management approach" />
                        <div><label className={labelCls}><Briefcase size={12} className="inline mr-1" />Key Responsibilities</label>
                            <textarea name="key_responsibilities" value={formData.key_responsibilities} onChange={handleInputChange} rows={3} className={inputCls} /></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}>Budget Management</label>
                                <input type="text" name="budget_management" value={formData.budget_management} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}>Disciplinary Philosophy</label>
                                <input type="text" name="disciplinary_philosophy" value={formData.disciplinary_philosophy} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                        <div><label className={labelCls}><Settings size={12} className="inline mr-1" />Tech Integration</label>
                            <input type="text" name="tech_integration" value={formData.tech_integration} onChange={handleInputChange} className={inputCls} /></div>
                    </div>
                );

            case "multimedia":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Video size={20} />} title="Multimedia & Additional" subtitle="Online presence and personal brand" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}><Video size={12} className="inline mr-1" />Video Intro</label>
                                <input type="text" name="video_intro" placeholder="YouTube link" value={formData.video_intro} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}><Link size={12} className="inline mr-1" />Portfolio Link</label>
                                <input type="text" name="portfolio_link" placeholder="Personal website" value={formData.portfolio_link} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                        <div><label className={labelCls}><Quote size={12} className="inline mr-1" />Personal Motto</label>
                            <input type="text" name="personal_motto" value={formData.personal_motto} onChange={handleInputChange} className={inputCls} /></div>
                    </div>
                );

            case "personalization":
                return (
                    <div className="space-y-5">
                        <SectionHeader icon={<Heart size={20} />} title="Personalization" subtitle="Quotes, hobbies and personal interests" />
                        <div><label className={labelCls}><Quote size={12} className="inline mr-1" />Favorite Quotes</label>
                            <textarea name="favorite_quotes" value={formData.favorite_quotes} onChange={handleInputChange} rows={2} className={inputCls} /></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className={labelCls}><Heart size={12} className="inline mr-1" />Hobbies <span className="normal-case font-normal">(comma separated)</span></label>
                                <input type="text" name="hobbies" value={formData.hobbies} onChange={handleInputChange} className={inputCls} /></div>
                            <div><label className={labelCls}><BookOpen size={12} className="inline mr-1" />Recommended Books <span className="normal-case font-normal">(comma separated)</span></label>
                                <input type="text" name="recommended_books" value={formData.recommended_books} onChange={handleInputChange} className={inputCls} /></div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <>
            {loading ? (
                <div className="w-full flex justify-center items-center min-h-[60vh]">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="flex flex-col lg:flex-row gap-5 w-full p-5 lg:p-6 min-h-screen">

                    {/* ── Left sidebar ── */}
                    <div className="w-full lg:w-64 xl:w-72 flex-shrink-0">
                        {/* Avatar card */}
                        <div className="bg-gradient-to-b from-[#D67C2C] to-[#c06a22] rounded-2xl shadow-md overflow-hidden mb-3">
                            <div className="px-6 pt-8 pb-6 flex flex-col items-center text-center">
                                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-3 shadow-md border-4 border-white/30">
                                    <User size={36} className="text-[#D67C2C]" />
                                </div>
                                <h3 className="text-white text-base font-bold leading-tight">{formData.name || "Admin User"}</h3>
                                <p className="text-orange-100 text-xs mt-0.5 truncate max-w-full">{formData.email || ""}</p>
                                <span className="mt-3 inline-flex items-center gap-1.5 bg-white/20 border border-white/30 text-white text-xs font-semibold px-3 py-1 rounded-full">
                                    <ShieldCheck size={11} />Administrator
                                </span>
                            </div>
                        </div>

                        {/* Nav menu card */}
                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                            <div className="px-3 py-2 border-b border-gray-100">
                                <p className="text-[10px] font-bold text-[#617587] uppercase tracking-widest px-2 py-1">Profile Sections</p>
                            </div>
                            <nav className="p-2 space-y-0.5">
                                {menuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        onClick={() => setActiveTab(item.id)}
                                        className={`w-full flex items-center justify-between gap-2.5 px-3 py-2.5 rounded-xl transition-all text-sm ${
                                            activeTab === item.id
                                                ? "bg-[#fff4eb] text-[#D67C2C] font-semibold"
                                                : "text-[#617587] hover:bg-gray-50 hover:text-[#1D3469]"
                                        }`}
                                    >
                                        <span className="flex items-center gap-2.5">
                                            <span className={activeTab === item.id ? "text-[#D67C2C]" : "text-gray-400"}>
                                                {item.icon}
                                            </span>
                                            {item.label}
                                        </span>
                                        {activeTab === item.id && <ChevronRight size={14} className="text-[#D67C2C]" />}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>

                    {/* ── Main content ── */}
                    <div className="flex-1 min-w-0 space-y-5">
                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                            {/* Content header strip */}
                            <div className="px-6 py-4 border-b border-gray-100 bg-[#F9FAFB] flex items-center justify-between">
                                <div>
                                    <h1 className="text-[15px] font-bold text-[#1D3469]">Admin Profile</h1>
                                    <p className="text-xs text-[#617587] mt-0.5">Manage your personal and professional information</p>
                                </div>
                                <button
                                    onClick={handleSubmit}
                                    disabled={saving}
                                    className="flex items-center gap-2 px-5 py-2.5 bg-[#D67C2C] hover:bg-[#c06a22] disabled:opacity-60 text-white text-sm font-semibold rounded-xl shadow-sm transition-all duration-200"
                                >
                                    {saving ? (
                                        <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                                    ) : (
                                        <Save size={15} />
                                    )}
                                    {saving ? "Saving…" : "Save Changes"}
                                </button>
                            </div>

                            {/* Form body */}
                            <div className="p-6">
                                {renderFormSection()}
                            </div>

                            {/* Footer save (convenience) */}
                            <div className="px-6 py-4 border-t border-gray-100 bg-[#F9FAFB] flex justify-end">
                                <button
                                    onClick={handleSubmit}
                                    disabled={saving}
                                    className="flex items-center gap-2 px-5 py-2.5 bg-[#D67C2C] hover:bg-[#c06a22] disabled:opacity-60 text-white text-sm font-semibold rounded-xl shadow-sm transition-all duration-200"
                                >
                                    {saving ? <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" /> : <Save size={15} />}
                                    {saving ? "Saving…" : "Save Changes"}
                                </button>
                            </div>
                        </div>
                        <BeneficiaryFeedbackCard />
                    </div>

                </div>
            )}
        </>
    );
};

export default ProfilePage;
